export default __webpack_public_path__ + "static/media/geoso-website.52a8bb79.png";